import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  categoryId: string;
  author: string;
  publishDate: string;
  readTime: string;
  image: string;
  tags: string[];
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  categoryId,
  author,
  publishDate,
  readTime,
  image,
  tags,
}: ArticleCardProps) {
  const category = categories.find((c) => c.id === categoryId);

  return (
    <article className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col">
      <Link to={`/article/${slug}`} className="block overflow-hidden">
        <div className="w-full aspect-[16/9] overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="flex flex-col flex-1 p-5">
        <div className="flex items-center gap-3 mb-3">
          {category && (
            <Link
              to={`/category/${category.slug}`}
              className="text-xs font-medium px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 hover:bg-primary-200 transition-colors whitespace-nowrap"
            >
              {category.name}
            </Link>
          )}
          <span className="text-xs text-foreground-500 whitespace-nowrap">{readTime}</span>
        </div>

        <Link to={`/article/${slug}`} className="block mb-2.5">
          <h3 className="text-lg font-bold font-heading text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 leading-snug">
            {title}
          </h3>
        </Link>

        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4 flex-1">
          {excerpt}
        </p>

        <div className="flex items-center justify-between pt-3 border-t border-background-200">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span>{author}</span>
            <span>·</span>
            <span>{publishDate}</span>
          </div>
          <Link
            to={`/article/${slug}`}
            className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}